import customerModel from "./customer.modal.js";
let customerResponse = [
  {
    name: "All",
    value: -1
  },
  {
    name: "Not Responded",
    value: 0
  },
  {
    name: "Cancelled",
    value: 1
  }
];
let status = [
  {
    name: "All",
    value: -1
  },
  {
    name: "Open",
    value: 0
  },
  {
    name: "Pending",
    value: 1
  },
  {
    name: "Assigned",
    value: 2
  },
  {
    name: "Job on Hold",
    value: 3
  },
  {
    name: "Appointment Open",
    value: 4
  },
  {
    name: "Appointment Pending",
    value: 5
  },
  {
    name: "Appointment Assigned",
    value: 6
  },
  {
    name: "Disposed",
    value: 7
  }
];
const fieldTypes = [
  {
    name: "Text",
    value: "text"
  },
  {
    name: "Textarea",
    value: "textarea"
  },
  {
    name: "Number",
    value: "number"
  },
  {
    name: "Phone",
    value: "phone"
  },
  {
    name: "Email",
    value: "email"
  },
  {
    name: "Address",
    value: "address"
  },
  {
    name: "Select",
    value: "select"
  },
  {
    name: "Autocomplete",
    value: "autocomplete"
  },
  {
    name: "Make",
    value: "make"
  },
  {
    name: "Make Unlocking",
    value: "make-unlocking"
  },
  {
    name: "Model",
    value: "model"
  },
  {
    name: "Year",
    value: "year"
  },
  {
    name: "Zipcode",
    value: "zipcode"
  }
];
const fixedFields = [
  "First Name",
  "Last Name",
  "Address",
  "Phone",
  "Email",
  "Total Flat Rate Price $",
  "Tax $"
];
const technicianTypes = [
  {
    name: "Outside Contractor",
    value: "1"
  },
  {
    name: "Inside Contractor",
    value: "2"
  },
  {
    name: "Employee",
    value: "3"
  },
  {
    name: "Dispatcher",
    value: "4"
  },
  {
    name: "Manager",
    value: "5"
  }
];
const formulas = [
  {
    name: "Add ( + )",
    value: "+"
  },
  {
    name: "Substract ( - )",
    value: "-"
  },
  {
    name: "Divide ( / ) ",
    value: "/"
  },
  {
    name: "Multiply ( x )",
    value: "*"
  }
];
const roles = [
  {
    name: "Admin",
    value: 1
  },
  {
    name: "Dispatcher",
    value: 2
  },
  {
    name: "Data Entry",
    value: 3
  },
  {
    name: "Dispatcher + Data Entry",
    value: 4
  }
];
const fixed_fields = {
  "First Name": customerModel.FIRST_NAME,
  "Last Name": customerModel.LAST_NAME,
  Phone: customerModel.PHONE
};
const fixed_order = {};
fixed_fields[customerModel.TAX] = 999;
fixed_fields[customerModel.TOTAL] = 1000;
fixed_fields[customerModel.BALANCE_DUE] = 1001;
export {
  customerResponse,
  status,
  fieldTypes,
  fixedFields,
  formulas,
  roles,
  fixed_fields,
  fixed_order,
  technicianTypes
};
